import request from '@/utils/request'

export default {
    getSystemLogs: async({ commit, dispatch }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            responseType: params.excel ? 'blob' : 'json',
            url: '/action-logs',
            params: {
                ...params,
                email: params.user,
                types: JSON.stringify(params.types)
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_SYSTEM_LOGS', res.data.items)
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    getTypes: async({ commit }) => {
        await request({
            method: 'get',
            url: '/action-types'
        }).then(res => {
            if (res.data) {
                commit('SET_TYPES', res.data)
            }
        })
    },

    updateTypes: ({ commit }, data) => {
        return request({
            method: 'put',
            url: '/action',
            data
        })
    }
}
